import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: null,
  pageSize: null,
  totalItems: null,
  totalPages: null,
  products: [],
  categories: [],
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    products: (state, action) => {
      if (action.payload && typeof action.payload === "object") {
        const { page, pageSize, totalItems, totalPages, products } =
          action.payload;
        state.page = page;
        state.pageSize = pageSize;
        state.totalItems = totalItems;
        state.totalPages = totalPages;
        if (products) state.products = products;
      } else {
        console.warn(
          "Invalid action payload for products reducer:",
          action.payload
        );
      }
    },
    categoriesProducts: (state, action) => {
      state.categories = action.payload || [];
    },
  },
});

// Export actions
export const { products, categoriesProducts } = productSlice.actions;

// Export reducer
export default productSlice.reducer;
